<template>
  <v-row class="justify-space-between mb-4">
    <v-col>
      <p style="color: #4477ad; font-size: 26px">
        {{ data.namePage }}
        <span style="margin-left: 5px">({{ getListFilter.length }})</span>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loading: false,
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapState({
      getListFilter(_, getters) {
        return getters[this.getPathStore + '/getListFilter']
      },
    }),
    getPathStore() {
      return this.data.path + 'Store'
    },
  },
}
</script>
